export default __webpack_public_path__ + "e2e3624d90b2d65b355b30cb92d17af3.png";